module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-latin18.f57a62e.woff2";